import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { sendAlert } from '../../actions/utils';
import { closeLeadRequest } from '../../requests/lead';
import { closeAdminLeadRequest } from '../../requests/admin/lead';
import { ModalBodyIcon } from '../Shared';

const CloseQuotationModal = ({
  fromAdmin,
  handleModalClose,
  isSuccess,
  leadId,
  modelUrl,
  selectedFile,
  selectedQuotation,
  setShowSuccessModal
}) => {
  const submitBtnText = isSuccess ? 'Cierre con éxito' : 'Cierre sin éxito';
  const variant = isSuccess ? 'submit' : 'strong-danger';
  const highlightedVariant = isSuccess ? 'light-success' : 'light-danger';
  const iconVariant = isSuccess ? 'success' : 'danger';
  const icon = isSuccess ? 'check-o' : 'close-o';
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSuccessRequest = () => {
    const kind = isSuccess ? 'success' : 'error';
    dispatch(sendAlert({ kind, message: submitBtnText }));
    if (isSuccess) setShowSuccessModal(true);
    else history.push(modelUrl);
  };

  const handleCloseLeadParams = () => {
    const closeStatus = isSuccess ? 'success' : 'failure';
    const sendParams = { close_status: closeStatus };
    if (isSuccess) {
      sendParams.lead_quotations_attributes = [{ id: selectedQuotation, acceptance: selectedFile, selected: true }];
    }
    return { lead: sendParams };
  };

  const handleCloseLeadRequest = () => {
    const sendParams = handleCloseLeadParams();
    const closeRequest = fromAdmin ? closeAdminLeadRequest : closeLeadRequest;
    closeRequest(leadId, {
      dispatch,
      params: sendParams,
      formData: true,
      successCallback: handleSuccessRequest
    });
  };

  return (
    <ModalBodyIcon
      icon={icon}
      iconVariant={iconVariant}
      content="Estás por hacer un"
      highlightedText={submitBtnText}
      highlightedVariant={highlightedVariant}
      formRequest={handleCloseLeadRequest}
      handleModalClose={handleModalClose}
      submitVariant={variant}
    />
  );
};

export default CloseQuotationModal;
